/**
 * Barradas Premium Store & CEDIS Locator Map Engine
 * Features: Leaflet + Google Maps XYZ tiles, Penguin branding, WhatsApp integration, Stats dropdowns
 */
(function () {
  'use strict';

  var PENGUIN_ICON_URL = 'https://cdn.shopify.com/s/files/1/0705/1699/8209/files/Icono_barradas-02_1.png?v=1778521329';

  window.BarradasLocationsMap = {
    instances: {},

    init: function (sectionId, options) {
      var container = document.getElementById('bdsBranchesFinder-' + sectionId);
      if (!container || container.dataset.bdsInit === 'true') return;
      container.dataset.bdsInit = 'true';

      var rawEl = document.getElementById('barradas-locations-raw-' + sectionId);
      if (!rawEl) return;

      var locations = [];
      try {
        locations = JSON.parse(rawEl.textContent.trim());
      } catch (e) {
        console.error('BarradasLocationsMap: Error parsing JSON locations data', e);
        return;
      }

      var self = this;
      var start = function (list) {
        self.instances[sectionId] = new LocatorMapInstance(sectionId, list, options);
      };

      // Sucursales vigentes desde la API de gestión; la lista incrustada es el respaldo.
      loadFromApi(options && options.apiUrl, locations).then(start, function (error) {
        if (error) console.warn('BarradasLocationsMap: se usa la lista guardada en el tema', error);
        start(locations);
      });
    }
  };

  var API_TIMEOUT_MS = 3000;
  var API_CACHE_KEY = 'barradas:locations-map:v2';
  var API_CACHE_MS = 10 * 60 * 1000;

  function isClosed(location) {
    var status = String(location && (location.estatus || location.status) || '').toLowerCase();

    return status === 'cerrada_temporalmente' ||
      status === 'cerrada_permanentemente' ||
      status === 'closed_temporarily' ||
      status === 'closed_permanently';
  }

  /*
   * Convierte la respuesta de gestion.grupobarradas.com/api/shopify/sucursales al formato de la
   * lista incrustada. Si una sucursal no trae coordenadas, se toman las de la lista incrustada
   * (mismo id), para no quitarla del mapa.
   */
  function fromApi(apiList, embedded) {
    var embeddedById = {};
    embedded.forEach(function (loc) { embeddedById[loc.id] = loc; });

    return apiList.map(function (s) {
      var saved = embeddedById[s.id] || {};
      return {
        id: s.id,
        nombre: s.nombre,
        categoria: s.tipo,
        empresa: 'barradas',
        direccion: s.direccion || '',
        colonia: s.colonia || '',
        codigo_postal: s.codigo_postal || '',
        ciudad: s.ciudad || '',
        estado: s.estado || '',
        direccion_completa: s.direccion_completa || '',
        lat: s.lat != null ? s.lat : saved.lat != null ? saved.lat : null,
        lng: s.lng != null ? s.lng : saved.lng != null ? saved.lng : null,
        telefonos: s.telefonos || [],
        horarios: s.horarios || '',
        website: saved.website || null,
        whatsapp: s.whatsapp || null,
        estatus: s.estatus || saved.estatus || 'abierta'
      };
    }).filter(function (location) { return !isClosed(location); });
  }

  function loadFromApi(apiUrl, embedded) {
    if (!apiUrl || !window.fetch) return Promise.reject(null);

    try {
      var cached = JSON.parse(sessionStorage.getItem(API_CACHE_KEY));
      if (cached && cached.url === apiUrl && Date.now() - cached.ts < API_CACHE_MS && cached.list.length) {
        return Promise.resolve(fromApi(cached.list, embedded));
      }
    } catch (e) {}

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, API_TIMEOUT_MS);

    return fetch(apiUrl, { headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined })
      .then(function (response) {
        if (!response.ok) throw new Error('API de sucursales: HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var list = (data && data.sucursales) || [];
        if (!list.length) throw new Error('API de sucursales sin datos');
        try {
          sessionStorage.setItem(API_CACHE_KEY, JSON.stringify({ url: apiUrl, ts: Date.now(), list: list }));
        } catch (e) {}
        return fromApi(list, embedded);
      })
      .finally(function () { clearTimeout(timer); });
  }

  function LocatorMapInstance(sectionId, locations, options) {
    var self = this;
    this.sectionId = sectionId;
    this.allLocations = (locations || []).filter(function (loc) {
      return !isClosed(loc) &&
             loc.categoria === 'sucursal' &&
             !/cedi/i.test(loc.nombre) &&
             !/distribuci/i.test(loc.nombre) &&
             loc.categoria !== 'pronego' &&
             !/pronego/i.test(loc.nombre);
    });

    this.options = Object.assign({
      tileLayer: 'google_streets',
      defaultZoom: 5,
      defaultCategory: 'all',
      visibleCount: 6,
      increment: 6
    }, options);

    this.visibleCount = this.options.visibleCount;
    this.currentCategory = this.options.defaultCategory || 'all';
    this.currentState = 'Todas';
    this.activeBranch = '';
    this.searchQuery = '';
    this.userCoords = null;
    this.map = null;
    this.markers = {};
    this.markersGroup = null;

    // DOM References
    this.section = document.getElementById('bdsBranchesFinder-' + sectionId);
    this.mapEl = document.getElementById('barradas-map-' + sectionId);
    this.grid = document.getElementById('bdsBranchesGrid-' + sectionId);
    this.searchInput = document.getElementById('bdsBranchSearch-' + sectionId);
    this.clearBtn = document.getElementById('bdsBranchClear-' + sectionId);
    this.summary = document.getElementById('bdsBranchSummary-' + sectionId);
    this.sentinelEl = document.getElementById('bdsInfiniteSentinel-' + sectionId);
    this.infiniteLoader = document.getElementById('bdsInfiniteLoader-' + sectionId);
    this.infiniteEnd = document.getElementById('bdsInfiniteEnd-' + sectionId);
    this.resetBtn = document.getElementById('bdsResetFilters-' + sectionId);
    this.geoBtn = document.getElementById('bdsGeoBtn-' + sectionId);
    this.isLoadingMore = false;
    this.observer = null;

    // Stats Dropdowns
    this.totalMetric = this.section.querySelector('[data-bds-total]');
    this.statesMetric = this.section.querySelector('[data-bds-states]');
    this.branchDropdownTrigger = document.getElementById('bdsBranchesDropdownTrigger-' + sectionId);
    this.stateDropdownTrigger = document.getElementById('bdsStatesDropdownTrigger-' + sectionId);
    this.branchDropdown = document.getElementById('bdsBranchesDropdown-' + sectionId);
    this.stateDropdown = document.getElementById('bdsStatesDropdown-' + sectionId);
    this.branchList = this.section.querySelector('[data-bds-branches-list]');
    this.stateList = this.section.querySelector('[data-bds-states-list]');

    this.initMap();
    this.buildStatsDropdowns();
    this.updatePillCounts();
    this.bindEvents();
    this.applyFilters();
  }

  LocatorMapInstance.prototype.initMap = function () {
    if (!this.mapEl || typeof L === 'undefined') return;

    var initialCenter = [20.0, -98.5];

    this.map = L.map(this.mapEl, {
      center: initialCenter,
      zoom: this.options.defaultZoom,
      scrollWheelZoom: true,
      zoomControl: true
    });

    // Google Maps XYZ Tile Layers
    var googleStreets = L.tileLayer('https://mt{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      maxZoom: 20,
      attribution: '&copy; Google Maps',
      subdomains: ['0', '1', '2', '3']
    });

    var googleHybrid = L.tileLayer('https://mt{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}', {
      maxZoom: 20,
      attribution: '&copy; Google Maps',
      subdomains: ['0', '1', '2', '3']
    });

    if (this.options.tileLayer === 'google_hybrid') {
      googleHybrid.addTo(this.map);
    } else {
      googleStreets.addTo(this.map);
    }

    var baseMaps = {
      "Google Calles": googleStreets,
      "Google Satélite": googleHybrid
    };

    L.control.layers(baseMaps, null, { position: 'topright' }).addTo(this.map);
    this.markersGroup = L.featureGroup().addTo(this.map);
  };

  LocatorMapInstance.prototype.getStates = function () {
    var states = [];
    this.allLocations.forEach(function (loc) {
      if (loc.estado && states.indexOf(loc.estado.trim()) === -1) {
        states.push(loc.estado.trim());
      }
    });
    return states.sort(function (a, b) {
      return a.localeCompare(b, 'es');
    });
  };

  LocatorMapInstance.prototype.countByState = function (st) {
    return this.allLocations.filter(function (l) {
      return l.estado && l.estado.trim() === st;
    }).length;
  };

  LocatorMapInstance.prototype.buildStatsDropdowns = function () {
    var self = this;
    var states = this.getStates();

    if (this.totalMetric) this.totalMetric.textContent = this.allLocations.length;
    if (this.statesMetric) this.statesMetric.textContent = states.length;

    if (this.branchList) {
      var bHtml = '<button type="button" class="bds-stat-option is-active" data-branch-name="">' +
        '<strong>Todas las sucursales</strong>' +
        '<span>Mostrar red completa (' + this.allLocations.length + ')</span>' +
        '</button>';

      this.allLocations.forEach(function (loc) {
        bHtml += '<button type="button" class="bds-stat-option" data-branch-name="' + self.escapeHtml(loc.nombre) + '" data-branch-id="' + loc.id + '">' +
          '<strong>' + self.escapeHtml(loc.nombre) + '</strong>' +
          '<span>' + self.escapeHtml(loc.ciudad) + ', ' + self.escapeHtml(loc.estado) + '</span>' +
          '</button>';
      });
      this.branchList.innerHTML = bHtml;
    }

    if (this.stateList) {
      var sHtml = '<button type="button" class="bds-stat-option is-active" data-state-name="Todas">' +
        '<strong>Todos los estados</strong>' +
        '<span>' + this.allLocations.length + ' sucursales</span>' +
        '</button>';

      states.forEach(function (st) {
        var count = self.countByState(st);
        sHtml += '<button type="button" class="bds-stat-option" data-state-name="' + self.escapeHtml(st) + '">' +
          '<strong>' + self.escapeHtml(st) + '</strong>' +
          '<span>' + count + ' ' + (count === 1 ? 'ubicación' : 'ubicaciones') + '</span>' +
          '</button>';
      });
      this.stateList.innerHTML = sHtml;
    }
  };

  LocatorMapInstance.prototype.updatePillCounts = function () {
    var allCount = this.allLocations.length;
    var elAll = document.getElementById('count-all');
    if (elAll) elAll.textContent = allCount;
  };

  LocatorMapInstance.prototype.bindEvents = function () {
    var self = this;

    // Search Input
    if (this.searchInput) {
      var timer = null;
      this.searchInput.addEventListener('input', function (e) {
        clearTimeout(timer);
        var val = e.target.value.trim();
        if (self.clearBtn) self.clearBtn.style.display = val.length > 0 ? 'block' : 'none';
        timer = setTimeout(function () {
          self.searchQuery = val.toLowerCase();
          self.activeBranch = '';
          self.visibleCount = self.options.visibleCount;
          self.applyFilters();
        }, 200);
      });
    }

    // Clear search
    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', function () {
        self.searchInput.value = '';
        self.clearBtn.style.display = 'none';
        self.searchQuery = '';
        self.visibleCount = self.options.visibleCount;
        self.applyFilters();
      });
    }

    // Filter Chips (Pills)
    var chips = this.section.querySelectorAll('.bds-finder__chip:not(#bdsGeoBtn-' + this.sectionId + ')');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        self.currentCategory = chip.dataset.category;
        self.visibleCount = self.options.visibleCount;
        self.applyFilters();
      });
    });

    // Geolocation Chip
    if (this.geoBtn) {
      this.geoBtn.addEventListener('click', function () {
        self.handleGeolocation();
      });
    }

    // Reset Filters button
    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', function () {
        self.resetFilters();
      });
    }

    // Setup Infinite Scroll
    this.setupInfiniteScroll();

    // Dropdown triggers
    if (this.branchDropdownTrigger) {
      this.branchDropdownTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        self.toggleDropdown(self.branchDropdown, self.branchDropdownTrigger);
      });
    }

    if (this.stateDropdownTrigger) {
      this.stateDropdownTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        self.toggleDropdown(self.stateDropdown, self.stateDropdownTrigger);
      });
    }

    // Branch selection in dropdown
    if (this.branchList) {
      this.branchList.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-branch-name]');
        if (!opt) return;
        self.activeBranch = opt.getAttribute('data-branch-name') || '';
        self.currentState = 'Todas';
        self.searchQuery = '';
        if (self.searchInput) self.searchInput.value = '';
        self.visibleCount = self.options.visibleCount;
        self.closeAllDropdowns();
        self.applyFilters();

        // Focus on map
        var branchId = opt.getAttribute('data-branch-id');
        if (branchId) {
          var targetLoc = self.allLocations.find(function (l) { return String(l.id) === String(branchId); });
          if (targetLoc) self.focusLocation(targetLoc);
        }
      });
    }

    // State selection in dropdown
    if (this.stateList) {
      this.stateList.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-state-name]');
        if (!opt) return;
        self.currentState = opt.getAttribute('data-state-name') || 'Todas';
        self.activeBranch = '';
        self.searchQuery = '';
        if (self.searchInput) self.searchInput.value = '';
        self.visibleCount = self.options.visibleCount;
        self.closeAllDropdowns();
        self.applyFilters();
      });
    }

    // Global click to close dropdowns
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-bds-close-dropdown]')) {
        self.closeAllDropdowns();
        return;
      }
      if (!e.target.closest('.bds-stat-dropdown') && !e.target.closest('.bds-locator__stat-card')) {
        self.closeAllDropdowns();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeAllDropdowns();
    });
  };

  LocatorMapInstance.prototype.toggleDropdown = function (dropdown, trigger) {
    if (!dropdown || !trigger) return;
    var willOpen = dropdown.hidden;
    this.closeAllDropdowns();
    dropdown.hidden = !willOpen;
    trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  };

  LocatorMapInstance.prototype.closeAllDropdowns = function () {
    if (this.branchDropdown) {
      this.branchDropdown.hidden = true;
      if (this.branchDropdownTrigger) this.branchDropdownTrigger.setAttribute('aria-expanded', 'false');
    }
    if (this.stateDropdown) {
      this.stateDropdown.hidden = true;
      if (this.stateDropdownTrigger) this.stateDropdownTrigger.setAttribute('aria-expanded', 'false');
    }
  };

  LocatorMapInstance.prototype.resetFilters = function () {
    this.searchQuery = '';
    this.currentState = 'Todas';
    this.activeBranch = '';
    this.currentCategory = 'all';
    this.visibleCount = this.options.visibleCount;

    if (this.searchInput) {
      this.searchInput.value = '';
      if (this.clearBtn) this.clearBtn.style.display = 'none';
    }

    var chips = this.section.querySelectorAll('.bds-finder__chip:not(#bdsGeoBtn-' + this.sectionId + ')');
    chips.forEach(function (c) {
      c.classList.toggle('is-active', c.dataset.category === 'all');
    });

    this.closeAllDropdowns();
    this.applyFilters();
  };

  LocatorMapInstance.prototype.applyFilters = function () {
    var self = this;

    this.filteredLocations = this.allLocations.filter(function (loc) {
      // Category check
      if (self.currentCategory !== 'all' && loc.categoria !== self.currentCategory) {
        return false;
      }

      // State check
      if (self.currentState !== 'Todas' && loc.estado && loc.estado.trim() !== self.currentState) {
        return false;
      }

      // Active branch check
      if (self.activeBranch && loc.nombre !== self.activeBranch) {
        return false;
      }

      // Search query check
      if (self.searchQuery) {
        var q = self.searchQuery;
        var haystack = [
          loc.nombre,
          loc.ciudad,
          loc.estado,
          loc.codigo_postal,
          loc.direccion,
          loc.colonia
        ].filter(Boolean).join(' ').toLowerCase();

        if (haystack.indexOf(q) === -1) {
          return false;
        }
      }

      return true;
    });

    // Distance calculation if user geolocated
    if (this.userCoords) {
      this.filteredLocations.forEach(function (loc) {
        if (loc.lat && loc.lng) {
          loc.distanceKm = self.calculateDistance(self.userCoords.lat, self.userCoords.lng, loc.lat, loc.lng);
        } else {
          loc.distanceKm = 99999;
        }
      });
      this.filteredLocations.sort(function (a, b) {
        return (a.distanceKm || 99999) - (b.distanceKm || 99999);
      });
    }

    this.render();
  };

  LocatorMapInstance.prototype.render = function () {
    this.renderList();
    this.renderMarkers();
    this.updateSummary();
  };

  LocatorMapInstance.prototype.updateSummary = function () {
    if (!this.summary) return;
    var total = this.filteredLocations.length;
    var visible = Math.min(this.visibleCount, total);

    if (this.activeBranch) {
      this.summary.textContent = 'Mostrando la sucursal ' + this.activeBranch + '.';
    } else if (this.currentState !== 'Todas') {
      this.summary.textContent = 'Mostrando ' + visible + ' de ' + total + ' sucursales en ' + this.currentState + '.';
    } else {
      this.summary.textContent = 'Mostrando ' + visible + ' de ' + total + ' sucursales.';
    }

    if (this.resetBtn) {
      var hasFilters = this.currentState !== 'Todas' || this.activeBranch !== '' || this.searchQuery || this.currentCategory !== 'all' || this.userCoords;
      this.resetBtn.style.display = hasFilters ? 'inline-block' : 'none';
    }
  };

  LocatorMapInstance.prototype.renderList = function () {
    var self = this;
    if (!this.grid) return;
    this.grid.innerHTML = '';

    if (this.filteredLocations.length === 0) {
      this.grid.innerHTML = '<div class="bds-empty">' +
        '<strong>No encontramos sucursales con ese criterio.</strong><br>' +
        'Intenta buscar por ciudad, estado o borrar los filtros aplicados.' +
        '</div>';
      if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'none';
      return;
    }

    var visible = this.filteredLocations.slice(0, this.visibleCount);

    visible.forEach(function (loc, index) {
      var card = document.createElement('article');
      card.className = 'bds-branch-card bds-card--' + loc.categoria;
      card.id = 'bds-card-' + self.sectionId + '-' + loc.id;
      card.setAttribute('tabindex', '0');

      var numberStr = String(index + 1).padStart(2, '0');
      var tagText = '🏬 Sucursal';

      var distanceHtml = '';
      if (loc.distanceKm && loc.distanceKm < 9000) {
        distanceHtml = '<span class="bds-branch-card__distance">A ' + loc.distanceKm.toFixed(1) + ' km</span>';
      }

      // Contact phone pill
      var contactHtml = '';
      if (loc.telefonos && loc.telefonos.length > 0) {
        contactHtml = '<div class="bds-branch-card__contact">' +
          '<span>📞 Tel. ' + self.escapeHtml(loc.telefonos[0]) + '</span>' +
          '</div>';
      }

      // Action Buttons: WhatsApp (if available) + Google Maps (side by side)
      var waButtonHtml = '';
      var hasWhatsApp = false;
      if (loc.whatsapp) {
        hasWhatsApp = true;
        var cleanWa = String(loc.whatsapp).replace(/[^\d]/g, '');
        if (cleanWa.length === 10) cleanWa = '52' + cleanWa;
        var waUrl = 'https://wa.me/' + cleanWa + '?text=' + encodeURIComponent('Hola, me interesa información sobre equipos comerciales en la sucursal ' + loc.nombre);

        waButtonHtml = '<a href="' + waUrl + '" target="_blank" rel="noopener noreferrer" class="bds-btn bds-btn--wa" onclick="event.stopPropagation();">' +
          '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2zm.01 1.67c4.55 0 8.24 3.7 8.24 8.24 0 2.2-.86 4.28-2.42 5.84a8.18 8.18 0 0 1-5.82 2.41h-.01c-1.44 0-2.86-.38-4.11-1.11l-.3-.17-3.12.82.83-3.04-.19-.31a8.18 8.18 0 0 1-1.25-4.44c0-4.54 3.7-8.24 8.25-8.24zm4.52 11.66c-.25-.13-1.47-.72-1.7-.81-.23-.08-.39-.13-.56.13-.17.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.13-1.06-.39-2.02-1.25-.75-.67-1.26-1.5-1.41-1.75-.15-.25-.02-.39.11-.51.11-.11.25-.29.37-.44.12-.14.17-.25.25-.42.08-.17.04-.31-.02-.44-.06-.13-.56-1.34-.76-1.84-.2-.49-.4-.42-.56-.43h-.47c-.17 0-.44.06-.67.31-.23.25-.88.86-.88 2.1 0 1.24.9 2.44 1.03 2.61.13.17 1.77 2.7 4.29 3.79.6.26 1.07.41 1.43.53.6.19 1.15.16 1.58.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.15-1.18-.06-.11-.22-.18-.47-.31z"/></svg>' +
          '<span>WhatsApp</span>' +
          '</a>';
      }

      var gmapsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + loc.lat + ',' + loc.lng;
      var actionsClass = hasWhatsApp ? 'bds-branch-card__actions' : 'bds-branch-card__actions bds-branch-card__actions--single';

      card.innerHTML = [
        '<div class="bds-branch-card__inner">',
        '  <div class="bds-branch-card__top">',
        '    <div class="bds-branch-card__icon" aria-hidden="true">',
        '      <img src="' + PENGUIN_ICON_URL + '" alt="Barradas">',
        '    </div>',
        '    <div>',
        '      <div class="bds-branch-card__kicker">',
        '        <span class="bds-branch-card__tag">' + tagText + '</span>',
        '        <span class="bds-branch-card__number">' + numberStr + '</span>',
        '        ' + distanceHtml,
        '      </div>',
        '      <h3 class="bds-branch-card__name">' + self.escapeHtml(loc.nombre) + '</h3>',
        '      <p class="bds-branch-card__city">' + self.escapeHtml(loc.ciudad) + ' · ' + self.escapeHtml(loc.estado) + '</p>',
        '    </div>',
        '  </div>',
        '  <p class="bds-branch-card__address">' + self.escapeHtml(loc.direccion_completa || loc.direccion) + '</p>',
        '  ' + contactHtml,
        '  <div class="' + actionsClass + '">',
        '    ' + waButtonHtml,
        '    <a href="' + gmapsUrl + '" target="_blank" rel="noopener noreferrer" class="bds-btn bds-btn--maps" onclick="event.stopPropagation();">',
        '      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a7 7 0 0 0-7 7c0 5.3 7 13 7 13s7-7.7 7-13a7 7 0 0 0-7-7Zm0 9.6A2.6 2.6 0 1 1 12 6.4a2.6 2.6 0 0 1 0 5.2Z"/></svg>',
        '      <span>Cómo llegar</span>',
        '    </a>',
        '  </div>',
        '</div>'
      ].join('');

      card.addEventListener('click', function () {
        self.focusLocation(loc);
      });

      self.grid.appendChild(card);
    });

    this.updateInfiniteStatus();
  };

  LocatorMapInstance.prototype.setupInfiniteScroll = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) {
      window.addEventListener('scroll', function () {
        if (self.isLoadingMore || self.visibleCount >= self.filteredLocations.length) return;
        if (self.sentinelEl) {
          var rect = self.sentinelEl.getBoundingClientRect();
          if (rect.top <= window.innerHeight + 250) {
            self.loadMore();
          }
        }
      }, { passive: true });
      return;
    }

    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) {
        if (!self.isLoadingMore && self.visibleCount < self.filteredLocations.length) {
          self.loadMore();
        }
      }
    }, {
      rootMargin: '250px 0px 250px 0px',
      threshold: 0
    });

    if (this.sentinelEl) {
      this.observer.observe(this.sentinelEl);
    }
  };

  LocatorMapInstance.prototype.loadMore = function () {
    var self = this;
    if (this.isLoadingMore || this.visibleCount >= this.filteredLocations.length) return;
    this.isLoadingMore = true;

    if (this.infiniteLoader) this.infiniteLoader.style.display = 'inline-flex';

    setTimeout(function () {
      self.visibleCount += self.options.increment;
      self.renderList();
      self.isLoadingMore = false;
      if (self.infiniteLoader) self.infiniteLoader.style.display = 'none';
      self.updateInfiniteStatus();
    }, 150);
  };

  LocatorMapInstance.prototype.updateInfiniteStatus = function () {
    var total = this.filteredLocations.length;
    var allLoaded = total === 0 || this.visibleCount >= total;

    if (this.infiniteLoader) this.infiniteLoader.style.display = 'none';

    if (this.infiniteEnd) {
      this.infiniteEnd.style.display = (allLoaded && total > this.options.visibleCount) ? 'block' : 'none';
    }

    if (this.sentinelEl) {
      this.sentinelEl.style.display = allLoaded ? 'none' : 'block';
    }
  };

  LocatorMapInstance.prototype.renderMarkers = function () {
    var self = this;
    if (!this.map || !this.markersGroup) return;

    this.markersGroup.clearLayers();
    this.markers = {};

    this.filteredLocations.forEach(function (loc) {
      if (!loc.lat || !loc.lng) return;

      var pinClass = 'bds-marker--sucursal';
      var innerHtml = '<img src="' + PENGUIN_ICON_URL + '" class="bds-marker-img" alt="Barradas">';

      var customIcon = L.divIcon({
        className: 'bds-custom-marker-wrap',
        html: '<div class="bds-marker-pin ' + pinClass + '">' + innerHtml + '</div>',
        iconSize: [38, 38],
        iconAnchor: [19, 38],
        popupAnchor: [0, -34]
      });

      var marker = L.marker([loc.lat, loc.lng], { icon: customIcon });

      var gmapsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + loc.lat + ',' + loc.lng;
      var waBtn = '';
      if (loc.whatsapp) {
        var cleanWa = String(loc.whatsapp).replace(/[^\d]/g, '');
        if (cleanWa.length === 10) cleanWa = '52' + cleanWa;
        var waUrl = 'https://wa.me/' + cleanWa + '?text=' + encodeURIComponent('Hola, me interesa información sobre equipos comerciales en ' + loc.nombre);
        waBtn = '<a href="' + waUrl + '" target="_blank" rel="noopener noreferrer" class="bds-btn bds-btn--wa"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2zm.01 1.67c4.55 0 8.24 3.7 8.24 8.24 0 2.2-.86 4.28-2.42 5.84a8.18 8.18 0 0 1-5.82 2.41h-.01c-1.44 0-2.86-.38-4.11-1.11l-.3-.17-3.12.82.83-3.04-.19-.31a8.18 8.18 0 0 1-1.25-4.44c0-4.54 3.7-8.24 8.25-8.24zm4.52 11.66c-.25-.13-1.47-.72-1.7-.81-.23-.08-.39-.13-.56.13-.17.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.13-1.06-.39-2.02-1.25-.75-.67-1.26-1.5-1.41-1.75-.15-.25-.02-.39.11-.51.11-.11.25-.29.37-.44.12-.14.17-.25.25-.42.08-.17.04-.31-.02-.44-.06-.13-.56-1.34-.76-1.84-.2-.49-.4-.42-.56-.43h-.47c-.17 0-.44.06-.67.31-.23.25-.88.86-.88 2.1 0 1.24.9 2.44 1.03 2.61.13.17 1.77 2.7 4.29 3.79.6.26 1.07.41 1.43.53.6.19 1.15.16 1.58.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.15-1.18-.06-.11-.22-.18-.47-.31z"/></svg> WhatsApp</a>';
      }

      var popupContent = [
        '<div class="bds-popup-body">',
        '  <div class="bds-popup-top">',
        '    <div class="bds-popup-icon-wrap">',
        '      <img src="' + PENGUIN_ICON_URL + '" class="bds-popup-icon" alt="Barradas">',
        '    </div>',
        '    <div>',
        '      <span class="bds-branch-card__tag" style="margin-bottom:3px;">🏬 Sucursal</span>',
        '      <h4 class="bds-popup-title">' + self.escapeHtml(loc.nombre) + '</h4>',
        '    </div>',
        '  </div>',
        '  <div class="bds-popup-addr">' + self.escapeHtml(loc.direccion_completa || loc.direccion) + '</div>',
        '  <div class="bds-popup-actions" style="grid-template-columns:' + (loc.whatsapp ? '1fr 1fr' : '1fr') + ';">',
        '    ' + waBtn,
        '    <a href="' + gmapsUrl + '" target="_blank" rel="noopener noreferrer" class="bds-btn bds-btn--maps">',
        '      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a7 7 0 0 0-7 7c0 5.3 7 13 7 13s7-7.7 7-13a7 7 0 0 0-7-7Zm0 9.6A2.6 2.6 0 1 1 12 6.4a2.6 2.6 0 0 1 0 5.2Z"/></svg>',
        '      Cómo llegar',
        '    </a>',
        '  </div>',
        '</div>'
      ].join('');

      marker.bindPopup(popupContent);

      marker.on('click', function () {
        self.highlightCard(loc.id);
      });

      self.markersGroup.addLayer(marker);
      self.markers[loc.id] = marker;
    });

    // Auto fit bounds
    if (this.filteredLocations.length > 0 && this.markersGroup.getLayers().length > 0) {
      try {
        var bounds = this.markersGroup.getBounds();
        if (bounds.isValid()) {
          this.map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
        }
      } catch (e) {}
    }
  };

  LocatorMapInstance.prototype.focusLocation = function (loc) {
    if (!this.map || !loc.lat || !loc.lng) return;

    this.map.flyTo([loc.lat, loc.lng], 16, { duration: 1.2 });

    var marker = this.markers[loc.id];
    if (marker) {
      marker.openPopup();
    }

    this.highlightCard(loc.id);

    // Scroll smoothly to map on mobile
    if (window.innerWidth < 1120) {
      this.mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  LocatorMapInstance.prototype.highlightCard = function (locId) {
    if (!this.grid) return;
    var cards = this.grid.querySelectorAll('.bds-branch-card');
    cards.forEach(function (c) { c.classList.remove('is-active'); });

    var target = document.getElementById('bds-card-' + this.sectionId + '-' + locId);
    if (target) {
      target.classList.add('is-active');
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  LocatorMapInstance.prototype.handleGeolocation = function () {
    var self = this;
    if (!navigator.geolocation) {
      alert('Tu navegador no soporta geolocalización.');
      return;
    }

    if (this.geoBtn) {
      this.geoBtn.innerHTML = '<span>Detectando...</span>';
    }

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        self.userCoords = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        };

        if (self.geoBtn) {
          self.geoBtn.classList.add('is-active');
          self.geoBtn.innerHTML = '<span>✓ Cerca de mí</span>';
        }

        self.applyFilters();

        if (self.filteredLocations.length > 0) {
          self.focusLocation(self.filteredLocations[0]);
        }
      },
      function (err) {
        console.warn('Geolocation error:', err);
        if (self.geoBtn) {
          self.geoBtn.innerHTML = '<span>No disponible</span>';
          setTimeout(function () {
            self.geoBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg><span>Cerca de mí</span>';
          }, 3000);
        }
      },
      { timeout: 10000, enableHighAccuracy: true }
    );
  };

  LocatorMapInstance.prototype.calculateDistance = function (lat1, lon1, lat2, lon2) {
    var R = 6371; // km
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  LocatorMapInstance.prototype.escapeHtml = function (val) {
    return String(val || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  };

})();
